import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import App from "./App.tsx";
import "../../../web-shared/login.css";
import "./styles.css";
import "./lib/i18n.ts";

// Service Worker（プッシュ通知の受信）登録
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[sw] register failed", err));
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// React マウント完了後にネイティブのスプラッシュを閉じる。
// 呼ばないと Capacitor のデフォルト timeout (3 秒) まで待たされ、その間
// 真っ白の WebView が見える。Web (PWA) 環境では SplashScreen は no-op。
if (Capacitor.isNativePlatform()) {
  SplashScreen.hide({ fadeOutDuration: 200 }).catch(() => {
    /* プラグイン未登録など。無視して継続 */
  });
}
